import { Dialog, Transition } from '@headlessui/react';

import "../../admin.css";

/**
 * Returns the Action Modal to accept/reject a project component.
 * 
 * @param {*} props 
 * @returns The Action Modal to accept/reject a project component.
 */
const ActionModal = (props) => {
    return (
        <>
            <Transition.Root show={props.show} as={props.as}>
                <Dialog as="div" className="relative z-10" initialFocus={props.initialFocus} onClose={props.onClose}>
                    <Transition.Child
                        as={props.as}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={props.as}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate1-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                    <div>
                                        <div className="mt-3 text-center sm:mt-5">
                                            <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                                                {props.selectedProject.name}
                                            </Dialog.Title>

                                            <div className="mt-2">
                                                <p className="text-sm text-gray-500">
                                                    Are you sure you want to approve this project to allow to associate large files?
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-5 sm:flex sm:justify-between sm:space-x-3">
                                        <button
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
                                            onClick={() => {
                                                props.setShow(true); 
                                                props.setOpen(false);
                                                props.setIsApprove(true);
                                            }} // Logic to approve selected project display response modal
                                        >
                                            Approve
                                        </button>

                                        <button
                                            type="button"
                                            className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:col-start-1 sm:mt-0 sm:text-sm"
                                            onClick={() => {
                                                props.setShow(true);
                                                props.setOpen(false);
                                                props.setIsApprove(false);
                                            }} // Logic to reject selected project display response modal
                                            ref={props.cancelButtonRef}
                                        >
                                            Reject
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    );
};
 
export default ActionModal;